/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabInventoryBill from './diag-lab-inventory-bill';
import DiagLabInventoryBillDetail from './diag-lab-inventory-bill-detail';
import DiagLabInventoryBillUpdate from './diag-lab-inventory-bill-update';
import DiagLabInventoryBillDeleteDialog from './diag-lab-inventory-bill-delete-dialog';

const DiagLabInventoryBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabInventoryBill />} />
    <Route path="new" element={<DiagLabInventoryBillUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabInventoryBillDetail />} />
      <Route path="edit" element={<DiagLabInventoryBillUpdate />} />
      <Route path="delete" element={<DiagLabInventoryBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabInventoryBillRoutes;
